import toast from 'react-hot-toast'
import { useDiplomacy, useMyFleet, useNegotiate } from '@/api/hooks'
import { NegotiationsPanel } from '@/components/NegotiationsPanel'
import { DiplomacyIcon } from '@/components/game/GameIcons'

/**
 * /negociations — « La table des négociations » : verser de l'or pour infléchir
 * son alignement (Diplomatie ↔ Corruption), 1 démarche/24 h, cap d'achat ±300.
 * Data + mutation ici ; NegotiationsPanel est présentationnel.
 */
export function Negotiations() {
  const { data: state, isLoading } = useDiplomacy()
  const { data: fleet } = useMyFleet()
  const negotiate = useNegotiate()

  return (
    <div className="max-w-2xl mx-auto p-4 sm:p-6 pb-16 space-y-7">
      <div className="text-center py-4">
        <p className="text-[11px] uppercase tracking-[0.32em] text-ocean-300 mb-3">Diplomatie & corruption</p>
        <h1 className="font-display text-4xl sm:text-5xl text-sand-300 inline-flex items-center gap-3">
          <DiplomacyIcon className="w-9 h-9 shrink-0" />
          La table des négociations
        </h1>
        <p className="text-ocean-100/80 mt-2 max-w-xl mx-auto">
          Verse de l'or pour infléchir ton allégeance (une démarche par 24 h, jamais au-delà de ±300).
          Tes actes restent ta vraie réputation.
        </p>
      </div>

      {isLoading || !state ? (
        <p className="text-center text-sm text-ocean-300">Chargement…</p>
      ) : (
        <NegotiationsPanel
          state={state}
          gold={fleet?.resources?.gold ?? null}
          pending={negotiate.isPending}
          onNegotiate={(direction, points) =>
            negotiate.mutate(
              { direction, points },
              {
                onSuccess: () => toast.success("Accord scellé. Ton allégeance s'infléchit."),
                onError: (err) => toast.error(err.message || 'La négociation a échoué.'),
              },
            )
          }
        />
      )}
    </div>
  )
}
